import { createBrowserRouter, Navigate, Outlet, useParams } from 'react-router';
import { AuthProvider } from './auth/AuthProvider';
import { AppLayout } from './components/layout/AppLayout';
import { AccountPage } from './pages/AccountPage';
import { AssetTypeDetailPage, AssetTypeListPage } from './pages/masterdata/AssetTypePages';
import { AssetDetailPage } from './pages/assets/AssetDetailPage';
import { AssetFormPage } from './pages/assets/AssetFormPage';
import { AssetListPage } from './pages/assets/AssetListPage';
import { DashboardPage } from './pages/DashboardPage';
import { DisposalDetailPage } from './pages/disposals/DisposalDetailPage';
import { DisposalListPage } from './pages/disposals/DisposalListPage';
import { DisposalWizardPage } from './pages/disposals/DisposalWizardPage';
import { EmployeeDetailPage, EmployeeListPage } from './pages/masterdata/EmployeePages';
import { LabelsPage } from './pages/LabelsPage';
import { LocationDetailPage, LocationListPage } from './pages/masterdata/LocationPages';
import { NotFoundPage } from './pages/NotFoundPage';
import { ScanPage } from './pages/ScanPage';
import { UserDetailPage, UserListPage } from './pages/admin/UserPages';
import { RequirePermission } from './pages/RequirePermission';
import { ReconciliationDetailPage, ReconciliationListPage } from './pages/reconciliations/ReconciliationPages';
import { BulkEditPage } from './pages/assets/BulkEditPage';

/** Ziel der QR-Codes: /a/IT-000123 → Asset-Detailseite. */
function QrRedirect() {
  const { ref = '' } = useParams();
  return <Navigate to={`/assets/${encodeURIComponent(ref)}`} replace />;
}

function Root() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}

export const router = createBrowserRouter([
  {
    element: <Root />,
    children: [
      { path: '/labels', element: <LabelsPage /> },
      {
        element: <AppLayout />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'a/:ref', element: <QrRedirect /> },
          { path: 'assets', element: <AssetListPage /> },
          { path: 'assets/new', element: <RequirePermission permission="asset:write"><AssetFormPage /></RequirePermission> },
          { path: 'assets/bulk', element: <RequirePermission permission="asset:write"><BulkEditPage /></RequirePermission> },
          { path: 'assets/:ref', element: <AssetDetailPage /> },
          { path: 'assets/:ref/edit', element: <RequirePermission permission="asset:write"><AssetFormPage /></RequirePermission> },
          { path: 'assets/:ref/dispose', element: <RequirePermission permission="asset:dispose"><DisposalWizardPage /></RequirePermission> },
          { path: 'scan', element: <ScanPage /> },
          { path: 'disposals', element: <DisposalListPage /> },
          { path: 'disposals/new', element: <RequirePermission permission="asset:dispose"><DisposalWizardPage /></RequirePermission> },
          { path: 'disposals/:ref', element: <DisposalDetailPage /> },
          { path: 'reconciliations', element: <ReconciliationListPage /> },
          { path: 'reconciliations/:id', element: <ReconciliationDetailPage /> },
          { path: 'employees', element: <EmployeeListPage /> },
          { path: 'employees/:ref', element: <EmployeeDetailPage /> },
          { path: 'locations', element: <LocationListPage /> },
          { path: 'locations/:ref', element: <LocationDetailPage /> },
          { path: 'asset-types', element: <AssetTypeListPage /> },
          { path: 'asset-types/:ref', element: <AssetTypeDetailPage /> },
          { path: 'users', element: <RequirePermission permission="user:manage"><UserListPage /></RequirePermission> },
          { path: 'users/:ref', element: <RequirePermission permission="user:manage"><UserDetailPage /></RequirePermission> },
          { path: 'account', element: <AccountPage /> },
          { path: '*', element: <NotFoundPage /> },
        ],
      },
    ],
  },
]);
